import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import {WorkspaceErrorBoundary} from "./components/WorkspaceErrorBoundary";
import {CanonicalRedirect} from "./components/CanonicalRedirect";
import {canonicalTarget} from "./canonicalOrigin";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
const destination = canonicalTarget(window.location.href);
if (destination) {
  root.render(<CanonicalRedirect destination={destination} />);
  window.location.replace(destination);
} else root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <WorkspaceErrorBoundary><App /></WorkspaceErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>,
);
